import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

import { ClientService } from '@app/core/client/services/client.service';

@Component({
  selector: 'filter-clients',
  templateUrl: './filter-clients.component.html',
  styleUrls: ['./filter-clients.component.scss'],
})
export class FilterClientsComponent implements OnInit {
  constructor(public clientSvc :ClientService) {}

  @Input() value :number[] | number;
  @Input() label :string = 'Client';
  @Output() changeClients :EventEmitter<number[] | number> = new EventEmitter<
    number[] | number
  >();
  @Input() options :{ multi :boolean } = { multi: false };

  client$ :Observable<any[]>;
  clientLoading = false;
  clientInput$ = new Subject<string>();

  ngOnInit() :void {
    this.loadClient();
  }

  onChange() {
    this.changeClients.emit(this.value);
  }

  trackClientByFn(item :any) {
    return item.id;
  }

  private loadClient() {
    this.client$ = concat(
      this.clientSvc.search(''),
      this.clientInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.clientLoading = true)),
        switchMap((term) =>
          this.clientSvc.search(term).pipe(
            catchError(() => of([])),
            tap(() => (this.clientLoading = false)),
          ),
        ),
      ),
    );
  }
}
